import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=3e90a70e&scoped=true&"
import script from "./ProductTile.vue?vue&type=script&lang=js&"
export * from "./ProductTile.vue?vue&type=script&lang=js&"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=3e90a70e&lang=scss&scoped=true&"
import style1 from "./ProductTile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90a70e",
  null
  
)

export default component.exports